import { ProductPlan } from "components/Payment/SubscriptionPlans";
import { AccordianItem } from "home/constants";

export interface SubscriptionPlan {
  id: number;
  level: string;
  experienceYears: string;
  deliverables: string[];
  price: number;
  setLoading: (loading: boolean) => void;
  productPlans: ProductPlan[];
  countryCode: string;
}

const writingDeliverables = [
  "Access 3 unique resume templates",
  "Lifetime editing via your dashboard",
  "Enjoy 1-month Resumemate Premium",
  "Personalized consultation with delivery in 2 days",
  "Track resume creation progress seamlessly",
];

export const subscriptionPlans = [
  {
    countryCode: "IN",
    id: 4,
    level: "Freshers",
    experienceYears: "0-2",
    deliverables: writingDeliverables,
    price: 699,
  },
  {
    countryCode: "IN",
    id: 5,
    level: "Mid-Senior",
    experienceYears: "2-5",
    deliverables: writingDeliverables,
    price: 999,
  },
  {
    countryCode: "IN",
    id: 6,
    level: "Professional",
    experienceYears: "5-10",
    deliverables: writingDeliverables,
    price: 1299,
  },
  {
    countryCode: "OTHERS",
    id: 10,
    level: "Freshers",
    experienceYears: "0-2",
    deliverables: writingDeliverables,
    price: 20,
  },
  {
    countryCode: "OTHERS",
    id: 11,
    level: "Mid-Senior",
    experienceYears: "2-5",
    deliverables: writingDeliverables,
    price: 30,
  },
  {
    countryCode: "OTHERS",
    id: 12,
    level: "Professional",
    experienceYears: "5-10",
    deliverables: writingDeliverables,
    price: 40,
  },
];

export const TestimonialData = [
  {
    id: 1,
    name: "MUDAVATH SRINU NAYAK",
    testimonial:
      "The resume-writing service was exceptional. The team helped me highlight my strengths and tailor my resume for my desired job role. Truly professional and impactful!",
    designation: "Product Designer",
    avtar: "/assets/sampleUserAvtar.png",
  },
  {
    id: 2,
    name: "Rahul Mandal",
    testimonial:
      "Amazing service! The experts took my rough resume and turned it into a polished, professional document. The feedback and suggestions were spot on.",
    designation: "UI/UX Designer",
    avtar: "/assets/sampleUserAvtar.png",
  },
  {
    id: 3,
    name: "Rutvi Champaneri",
    testimonial:
      "Your resume-writing service saved me so much time! The team helped me craft a resume that not only looked great but also communicated my skills effectively.",
    designation: "Marketing Specialist",
    avtar: "/assets/sampleUserAvtar.png",
  },
  {
    id: 4,
    name: "Kundan Singh",
    testimonial:
      "Wonderful experience! The personalized guidance and professional touch made my resume stand out. I landed interviews within days of using my new resume.",
    designation: "Software Engineer",
    avtar: "/assets/sampleUserAvtar.png",
  },
  {
    id: 5,
    name: "Bibek Chaudhary",
    testimonial:
      "They understood exactly what I needed! My resume now reflects my experience and skills. A must-try service for anyone looking to level up their job applications.",
    designation: "Business Analyst",
    avtar: "/assets/sampleUserAvtar.png",
  },
  {
    id: 6,
    name: "Pratik Sharma",
    testimonial:
      "The team was quick, responsive, and highly skilled. They revamped my resume and provided tips for interviews. I feel so much more confident in my job search now!",
    designation: "Project Manager",
    avtar: "/assets/sampleUserAvtar.png",
  },
  {
    id: 7,
    name: "Shivam Monga",
    testimonial:
      "Their resume-writing service is phenomenal! The attention to detail and professionalism exceeded my expectations.",
    designation: "Data Analyst",
    avtar: "/assets/sampleUserAvtar.png",
  },
  {
    id: 8,
    name: "Ritam Dey",
    testimonial:
      "I had no idea where to start with my resume, but this service made it easy. The final product was clean, concise, and tailored to the industry I’m targeting.",
    designation: "Finance Consultant",
    avtar: "/assets/sampleUserAvtar.png",
  },
  {
    id: 9,
    name: "Haritha Relli",
    testimonial:
      "Never thought my resume could look this professional! The service was quick, and the team was so helpful. I feel confident applying for my dream roles now.",
    designation: "Human Resources Manager",
    avtar: "/assets/sampleUserAvtar.png",
  },
  {
    id: 10,
    name: "Niharendu Biswas",
    testimonial:
      "The best resume-writing service I’ve used! They delivered a resume that showcases my achievements perfectly. It’s worth every penny.",
    designation: "Operations Manager",
    avtar: "/assets/sampleUserAvtar.png",
  },
];

export enum Status {
  notSubscribed = "NOT_SUBSCRIBED",
  submitPending = "SUBMIT_PENDING",
  submitted = "SUBMITTED",
  consultation = "CONSULTATION",
  progress = "PROGRESS",
  review = "REVIEW",
  completed = "COMPLETED",
}

export interface ResumeStatusItem {
  status: Status;
  name: string;
  description: string;
}

export const ResumeStatus: ResumeStatusItem[] = [
  {
    status: Status.notSubscribed,
    name: "Not Subscribed",
    description: "You have not subscribed to any package yet.",
  },
  {
    status: Status.submitPending,
    name: "Submit Pending",
    description: "You have submitted your resume for revamp.",
  },
  {
    status: Status.submitted,
    name: "Submitted",
    description: "Your resume has been submitted for revamp.",
  },
  {
    status: Status.consultation,
    name: "Consultation",
    description: "Your consultation is scheduled for tomorrow.",
  },
  {
    status: Status.progress,
    name: "In Progress",
    description: "Your resume is being revamped.",
  },
  {
    status: Status.review,
    name: "Review",
    description: "Your resume is under review.",
  },
  {
    status: Status.completed,
    name: "Completed",
    description: "Your resume has been revamped. Enjoy!",
  },
];

export const FAQData: AccordianItem[] = [
  {
    id: 1,
    ques: "Is the resume writing service free?",
    ans: "No, our resume writing service is a premium offering. However, it’s designed to deliver exceptional value with professional resumes tailored to your needs.",
  },
  {
    id: 2,
    ques: "What makes your resume writing service unique?",
    ans: "Our service combines personalized consultations with expert writers and ATS-friendly formatting, ensuring your resume not only looks great but also meets industry standards.",
  },
  {
    id: 3,
    ques: "Can I provide my existing resume for updates?",
    ans: "Absolutely! You can share your current resume with us, and our experts will enhance it by highlighting your skills, achievements, and experience effectively.",
  },
  {
    id: 4,
    ques: "What does ‘ATS-friendly’ mean?",
    ans: "‘ATS-friendly’ means your resume is optimized for Applicant Tracking Systems, ensuring it passes initial screenings and grabs recruiters' attention.",
  },
  {
    id: 5,
    ques: "How long does the process take?",
    ans: "Our resume writing service typically delivers your professionally written resume within 2 business days after consultation.",
  },
  {
    id: 6,
    ques: "Will my information remain confidential?",
    ans: "Yes, your data is completely secure with us. We respect your privacy and ensure that your personal and professional details are kept confidential.",
  },
];
